export default {
  methods: {
    validateFields(fields = [], refName = 'form') {
      fields.forEach((field) => {
          this.validateField(field, refName);
      });
    },
    validateField(modelName, refName = 'form') {
      const formFields = this.$refs[refName].$children;

      formFields.forEach((formField) => {
        if (formField.field.model === modelName) {
          formField.$refs.child.validate();
        }
      });
    },
    validateGroupedField(modelName, groupModelName, refName = 'form') {
      const formFields = this.$refs[refName].$children;

      // could not find a more direct way to get the wanted field...
      // Although we cycling loops on loops, this is still a very light method
      // as we will never be dealing with large amounts of data.
      // In most of the cases, we are looping through only 1 value.

      formFields.forEach((formField) => {
        if (formField.field.model === groupModelName) {
          formField.$children.forEach((group) => {
            group.$children.forEach((childGroup) => {
              childGroup.$children.forEach((childFormField) => {
                childFormField.$children.forEach((field) => {

                  if (field.field.model === modelName) {
                    field.$refs.child.validate();
                  }
                });
              });
            });
          });
        }
      });
    },
    validateAdditiveField(modelName, groupModelName, refName = 'form') {
      const formFields = this.$refs[refName].$children;

      formFields.forEach((formField) => {
        formField.$children.forEach((row) => {
          if (row.field && row.field.model === groupModelName) {
            row.$children.forEach((group) => {
              group.$children.forEach((childGroup) => {
                childGroup.$children.forEach((childFormField) => {
                  childFormField.$children.forEach((field) => {

                    if (field.field.model === modelName) {
                      field.$refs.child.validate();
                    }
                  });
                });
              });
            });
          }
        });
      });
    },
  },
};
